import { useState } from "react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubmitted(true);
      setEmail("");
    }
  };

  return (
    <section className="relative bg-[#2c2a4a] py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=1920&q=80"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative container mx-auto px-4 text-center">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-[42px] font-bold text-white mb-4">
          Join the SpinWorld Family
        </h2>
        <p className="text-white/80 max-w-xl mx-auto mb-10 text-base md:text-lg">
          Get exclusive offers, new product alerts, and garden inspiration delivered to your inbox.
        </p>

        {submitted ? (
          <div className="max-w-md mx-auto bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <p className="text-white font-medium">
              Thank you for subscribing! Welcome to the SpinWorld family.
            </p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="max-w-md mx-auto flex flex-col sm:flex-row gap-3"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              className="flex-1 px-5 py-4 rounded-md bg-white text-[#2A2A2A] placeholder:text-gray-400 text-base focus:outline-none focus:ring-2 focus:ring-[#B87333]"
            />
            <button
              type="submit"
              className="px-8 py-4 bg-[#4f528d] text-white font-medium text-base rounded-md hover:bg-[#3d4070] transition-colors whitespace-nowrap"
            >
              Subscribe
            </button>
          </form>
        )}

        <p className="text-white/50 text-sm mt-5">
          We respect your privacy. Unsubscribe at any time.
        </p>
      </div>
    </section>
  );
}